import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import { ABS_ASSET_CLASS_ID } from '@/creditflowresearch/application/Bonds/constants';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import AsyncList from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/AsyncList/AsyncList';
import { useTraceAssetClasses } from '@/creditflowresearch/application/Trace/TraceAssetClassesContext';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { getContainer } from '@framework/di/getContainer';
import TraceRepository from '@/creditflowresearch/infrastructure/repository/TraceRepository';
import widenDateToForRpc from '@/creditflowresearch/application/Trace/widenDateToForRpc';

const IssuerListContainer = (props) => {
  const { getFiltersByFilterName } = useFiltersContext();
  const selectedValues = getFiltersByFilterName(TRACE_STORE_NAME, props.filterName);
  const { filtersPayload: traceFilters } = useTraceFiltersContext();
  const { currentAssetClass } = useTraceAssetClasses();
  const container = getContainer();
  const traceRepository = container.get(TraceRepository);

  const getTraceIssuers = (search) => traceRepository.getTraceIssuersFilter(
      widenDateToForRpc({
        ...traceFilters,
        includedAssetClassId: currentAssetClass?.id || ABS_ASSET_CLASS_ID,
      }), search);

  const optionsMapper = (option) => ({
    value: option.id,
    label: option.name,
    issuerTicker: option.issuerTicker,
  });

  return (
    <AsyncList
      { ...props }
      loadOptions={ getTraceIssuers }
      selectedValues={ selectedValues || [] }
      optionsMapper={ optionsMapper }
    />
  );
};

export default IssuerListContainer;
